import { ChevronDown } from "lucide-react";
import { useDispatch } from "react-redux";
import IconUI from "./IconUI";
import { useEffect, useRef, useState } from "react";

export default function EditorDropDownCard({

    width = "180px",
    activeCard,
    icon,
    title,

    onClickPopup,
    onClickBackObject,

    hasDropDown = false,
    dropDownObjectI = []

}) {
 const [open, setOpen] = useState(false);

const ref = useRef();
    const dispatch = useDispatch();
useEffect(() => {

    function handleClick(e){

        if(
            ref.current &&
            !ref.current.contains(e.target)
        ){
            setOpen(false);
        }

    }

    document.addEventListener(
        "mousedown",
        handleClick
    );

    return ()=>{

        document.removeEventListener(
            "mousedown",
            handleClick
        );

    };

},[]);
    function handleMouseEnter() {

        dispatch({ type: "CURSOR", payload: true });
        dispatch({ type: "CURSORTEXT", payload: "" });
        dispatch({ type: "CURSORTEXTBG", payload: "" });
        dispatch({ type: "CURSORTEXTCOLOR", payload: "" });

    }

    function handleMouseLeave() {

        dispatch({ type: "CURSOR", payload: false });

        dispatch({ type: "CURSORTEXT", payload: "" });
        dispatch({ type: "CURSORTEXTBG", payload: "" });
        dispatch({ type: "CURSORTEXTCOLOR", payload: "" });

    }

    function scrollToSection(item){

        if(!item?.id) return;

        const target = document.getElementById(item.id);

        if(!target) return;

        target.scrollIntoView({

            behavior:"smooth",
            block:"center"

        });

        target.style.transition="all .3s";

        target.style.outline="2px solid #90CAF9";
        target.style.outlineOffset="4px";

        setTimeout(()=>{

            target.style.outline="none";

        },1200);

    }

    return(

        <div

          ref={ref}

    className="editor-dropdown-card"

    style={{ width }}


            onMouseEnter={handleMouseEnter}

            onMouseLeave={handleMouseLeave}
onClick={() => {

    onClickPopup?.();

    if(hasDropDown){

        setOpen(previous => !previous);

    }

}}
        >

            <div

                className={`editor-dropdown-icon ${
                    activeCard ? "active" : ""
                }`}

            >

                <IconUI
                    icon={icon}
                    size={22}
                />

            </div>

            <div className="editor-dropdown-title">

                {title}

            </div>

           {
    hasDropDown &&

    <ChevronDown

        size={18}

        className={`editor-dropdown-arrow ${
            open
                ? "open"
                : ""
        }`}

    />
}

            {

    hasDropDown &&
    open &&

    <div className="editor-dropdown-menu" style={{width}}>

        {dropDownObjectI.map((item,index)=>

            <div

                key={item.id || index}

                className="editor-dropdown-item"

                onClick={e=>{

                    e.stopPropagation();

                    setOpen(false);

                    scrollToSection(item);

                    onClickBackObject?.(item);

                }}

            >

                <IconUI
                    icon={index}
                    size={16}
                />

                <span>

                    {item.name}

                </span>

            </div>

        )}

    </div>

}
<style>{`.editor-dropdown-card{

    position:relative;

    display:flex;

    align-items:center;

    gap:10px;

    height:38px;

    padding:6px 10px;

    border-radius:10px;

    cursor:pointer;

    transition:.18s;

}

.editor-dropdown-card:hover{

    background:#F8FAFC;

}

.editor-dropdown-icon{

    width:28px;
    height:28px;

    display:flex;

    align-items:center;

    justify-content:center;

    border-radius:8px;

    background:#F3F4F6;

}.editor-dropdown-arrow{

    transition:.2s;

}

.editor-dropdown-arrow.open{

    transform:rotate(180deg);

}

.editor-dropdown-icon.active{

    background:#90CAF9;

    color:#FFF;

}

.editor-dropdown-title{

    flex:1;

    font-size:13px;

    font-weight:600;

    color:#334155;

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

}

.editor-dropdown-arrow{

    color:#94A3B8;

}

.editor-dropdown-menu{

    position:absolute;

    top:42px;

    left:0;

    width:160px;

    background:#FFF;

    border:1px solid #E5E7EB;

    border-radius:12px;

    box-shadow:
        0 15px 40px rgba(15,23,42,.12);

    overflow:hidden;

    z-index:1000;

}

.editor-dropdown-item{

    display:flex;

    align-items:center;

    gap:10px;

    padding:10px 14px;

    cursor:pointer;

    transition:.15s;

}

.editor-dropdown-item:hover{

    background:#F8FAFC;

}`}</style>
        </div>

    );

}



// import React,{useState,useEffect,useRef} from "react";

//   import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
// import { useHistory,} from "react-router-dom";

// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
//   TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
//   List,
//   Grid2x2X,
//   Grid2X2,
//   Grid2x2,
//   ListTodo,
//   ChevronLeft,
//   ChevronDown} from 'lucide-react';
// import IconUI from "../../../../UI/IconUI";

// const EditorDropDownCard =({width,activeCard,icon,title ,onClickPopup,onClickBackObject,hasDropDown,dropDownObjectI})=>{

//     const [hasDropDownI ,setHasDropDownI] =useState(hasDropDown)
// //  const [dropDownObjectI ,setDropDownObjectI] =useState([{title:"Home",},{title:"About Us",},{title:"Testimonials",},{title:"Courses",},{title:"Blogs",},
// //      {title:"Workshops",},{title:"Course Page",},{title:"Dashboard Page",},
// //  ])

//      const dispatch = useDispatch();
     
      
//     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
//         {
          
//           dispatch({type: "CURSOR",payload:true  });
      
//           dispatch({type: "CURSORTEXT",payload:CursorText})
//           dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
//           dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
//         }
         
//         const handleMouseLeave = () => {
          
//           dispatch({type: "CURSOR",payload:false})
      
//           dispatch({type: "CURSORTEXT",payload:""})
      
//           dispatch({type: "CURSORTEXTBG",payload:""})
//           dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
//       }
//       const cardBg ="#fff";
//       const styleCard={marginBottom:"0px",width:width,height:"38x",cursor:"pointer",background:cardBg,border:"0px solid #fff",padding:"5px",zIndex:999}
//       const cardBgIcon =activeCard?"rgba(255,114,94,0.7)":" #f9f9f9";
//       const styleCardIconIcon={background:cardBgIcon,width:"30px",height:"20px",borderRadius:"15%",
//         alignContent:"center",textAlign:"center",padding:"0px",}
//       return (<>
//         <div   onMouseEnter={
//                 ()=>handleMouseEnter("","","")}
// onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()} align="left" className="itemPageDropDounMenu"
//  style={styleCard} > 
// <div style={styleCardIconIcon}>{<IconUI size={23} icon={icon}/>}</div>
//  <div className=" TitleWithEllipsis" style={{fontSize:"13px",padding:"3px 15px",color:"rgba(144, 202, 249,1)",paddingLeft:"5px",width:"120px",textAlign:"left",fontWeight:"bold"}}>{title}</div>
// {hasDropDownI?<div style={{position:"absolute",right:"5px",top:"-3px",padding:"6px",width:"24px",height:"24px",borderRadius:"50%",background:"#ffff"}}>{<ChevronDown size={25}   color="#90CAF9" />}</div>:""}
//  {hasDropDownI?<div className="itemPageDropDounMenuInn" style={{top:"27px",height:"140px"}}>
//      {dropDownObjectI?.map(
//   (item, index) => (

//     <div
//       key={index}

//       onMouseEnter={() => {

//         handleMouseEnter(
//           "",
//           "",
//           ""
//         );

//         /* =====================================
//            AUTO SCROLL TO SECTION
//         ====================================== */

//         if (item?.id) {

//           const target =
//             document.getElementById(
//               item.id
//             );

//           if (target) {

//             target.scrollIntoView({
//               behavior: "smooth",

//               block: "center"
//             });

//             /* OPTIONAL HIGHLIGHT */

//             target.style.transition =
//               "all 0.3s ease";

//             target.style.outline =
//               "2px solid #90CAF9";

//             target.style.outlineOffset =
//               "4px";

//             setTimeout(() => {

//               target.style.outline =
//                 "none";

//             }, 1200);
//           }
//         }
//       }}

//       onMouseLeave={() => {

//         handleMouseLeave();
//       }}

//       onClick={() => {

//         onClickBackObject(item);
//       }}

//       align="left"

//       className="itemPageDropDounMenuTitle"

//       style={{
//         height: "25px",

//         display: "flex",

//         justifyContent: "left",

//         alignItems: "center"
//       }}
//     >
//       <IconUI
//         size={18}
//         icon={index}
//       />

//       <div
//         className="TitleWithEllipsis"
//         style={{
//           fontSize: "12px",

//           padding: "7px 10px",

//           textAlign: "center",

//           fontWeight: "bold"
//         }}
//       >
//         {item?.name}
//       </div>
//     </div>
//   )
// )}
//     {/* <div   onMouseEnter={
//                 ()=>handleMouseEnter("","","")}
// onMouseLeave={handleMouseLeave}  onClick={()=>{}} align="left" className="itemPageDropDounMenuTitle"
//   >
//     <div className=" TitleWithEllipsis" style={{fontSize:"12px",padding:"7px 10px",textAlign:"center",fontWeight:"bold"}}>+ New </div> </div> */}
//  </div>:<></>}
//    </div></>)
// }
// export default EditorDropDownCard;

